import {
  FilterActions,
  MainAttributeFilterSelectionEvent,
  RESET_FILTER_SELECTION,
} from '../../../types';
import {FilterLabels} from '../../../types/tracking-filter-selection';
import {trackFilterSelection} from './trackFilterSelection';

export const trackMainFilterSelection = ({
  selection,
  action,
  label,
}: {
  selection: MainAttributeFilterSelectionEvent | typeof RESET_FILTER_SELECTION;
  action: FilterActions;
  label: FilterLabels;
}) =>
  trackFilterSelection({
    selection:
      selection === RESET_FILTER_SELECTION
        ? selection
        : {...selection, type: 'main'},
    action,
    label,
  });
